import styled from "styled-components";
import Container from "../../../Components/Container";
import Row from "../../../Components/Row";
import { Icon } from "@iconify/react";
import BannerSite2 from "../../../assets/images/mock_follow_2.svg";
import { ResponsiveImage, Subtitle, Title } from "./styles";

const strategyItems = [
  "Defina instruções, objetivos, dias, horários e a base de contatos",
  "O Alfred analisa o histórico e contexto para decidir quem deve receber",
  "Cada contato recebe uma abordagem personalizada no Whatsapp",
  "Acompanhe tudo em tempo real: envios, falhas, ignoradas e performance",
];

const StrategyList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 0;
  margin: 0;
  list-style: none;
`;

const StrategyItem = styled.li`
  display: grid;
  grid-template-columns: 27px 1fr;
  gap: 16px;
  align-items: flex-start;
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
  line-height: 30px;
  text-align: left;
`;

const FollowUpStrategy = () => {
  return (
    <Container style={{ textAlign: "center", background: "#000000" }}>
      <Row
        xs="1fr"
        sm="1fr"
        md="1fr 38%"
        lg="1fr 38%"
        xl="1fr 38%"
        style={{ marginTop: "80px" }}
      >
        <div>
          <Title>
            Você cria a estratégia. O{" "}
            <span style={{ color: "#E4DA1B", fontWeight: 600 }}>Alfred</span>{" "}
            executa com inteligência.
          </Title>
          <Subtitle>
            Defina objetivos, dias, horários e instruções. <br />O Alfred cuida
            do resto: analisa, decide, gera e envia mensagens que fazem sentido
            para cada cliente.
          </Subtitle>
          <StrategyList>
            {strategyItems.map((item) => (
              <StrategyItem key={item}>
                <Icon icon="mdi:check-circle" color="#e4da1b" width={27} height={27} style={{ marginTop: 2 }} />
                <span>{item}</span>
              </StrategyItem>
            ))}
          </StrategyList>
          <br />
        </div>
        <div>
          <ResponsiveImage src={BannerSite2} alt="banner" />
        </div>
      </Row>
    </Container>
  );
};

export default FollowUpStrategy;
